import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { getCategoryTabId, getPlusExclusiveCampaign } from '@client/redux/modules/mylounge';
import { CategoryTabIds } from '@shared/constants';
import { usePlusExclusive } from '@browsing/hooks';

/**
 * My lounge layout simulation.
 * this is a simulation to better understanding of the position of the exclusive campaign card.
 *
 * |X| is Top Picks
 * |_| is a regular campaign card
 *
 * 1 column
 * |_|
 * |_|
 * |_|
 * |X|
 * |_|
 *
 * 2 columns
 * |___|
 * |_|_|
 * |XXX|
 * |___|
 * |_|_|
 * |___|
 *
 * 3 columns
 * |   |_|
 * |___|_|
 * |XXXXX|
 * |_|___|
 * |_| |_|
 * |_|_|_|
 *
 * 4 columns
 * |   |_|_|
 * |___|___|
 * |XXXXXXX|
 * |_| |_|_|
 * |_|_|___|
 */
export const usePlusExclusiveCampaignPosition = ({
    columnCount,
    offset = 0,
}: {
    columnCount: number;
    /**
     * @description We adjust the position of the exclusive campaign card by this offset if we have early access campaigns \
     * probably we will have max 3 early access campaigns as same time, so we apply the offset if the return value is less than 3
     */
    offset?: number;
}): number => {
    const DO_NOT_RENDER = -1;
    const isPlusExclusiveEnabled = usePlusExclusive();
    const categoryTabId = useSelector(getCategoryTabId);
    const exclusiveCampaign = useSelector(getPlusExclusiveCampaign);

    if (!isPlusExclusiveEnabled) {
        return DO_NOT_RENDER;
    }

    if (!exclusiveCampaign) {
        return DO_NOT_RENDER;
    }

    if (categoryTabId !== CategoryTabIds.ALL) {
        return DO_NOT_RENDER;
    }

    if (exclusiveCampaign?.startsAt === undefined) {
        return DO_NOT_RENDER;
    }

    const exclusiveCampaignStartDate = dayjs(exclusiveCampaign.startsAt);

    const today = dayjs();

    let valueToReturn = today.diff(exclusiveCampaignStartDate, 'day');

    valueToReturn += offset;

    if (valueToReturn === 0) {
        return 0;
    }

    if (columnCount === 1) {
        return 3;
    }

    if (columnCount === 2) {
        return 4;
    }

    if (columnCount === 3) {
        return 5;
    }

    if (columnCount === 4) {
        return 3;
    }

    return DO_NOT_RENDER;
};
